import axios from "axios";
import { API_URL } from "../config";
import { user } from "./actions_helper";

// Fetches a short-lived, session-token-free download URL from an authenticated
// mint endpoint. The returned URL is either a presigned S3 URL (prod) or a
// signed `/downloads?sig=` link (dev) — both publicly fetchable, so they work
// in a new tab, an <img src>, and Chromium drag-out, none of which can send an
// auth header. See the server's SignedDownload service / DownloadsController.
async function fetchSignedUrl(path: string): Promise<string> {
    const { data } = await axios.get(`${API_URL}${path}`, {
        headers: { authorization: user().token },
    });
    return data.url;
}

export const fetchFormEntryPdfUrl = (id: string | number): Promise<string> =>
    fetchSignedUrl(`/form_entries/${id}/pdf_url`);

export const fetchUploadDownloadUrl = (id: string | number): Promise<string> =>
    fetchSignedUrl(`/uploads/${encodeURIComponent(id)}/download_url`);

export const fetchFormEntryAssetUrl = (uuid: string): Promise<string> =>
    fetchSignedUrl(`/form_entry_assets/url?uuid=${encodeURIComponent(uuid)}`);

// Opens a signed download in a new tab without tripping popup blockers: the
// blank tab is opened synchronously on the user gesture, then redirected once
// the (async) signed URL resolves.
export async function openSignedUrl(urlPromise: Promise<string>): Promise<void> {
    const win = window.open("", "_blank");
    try {
        const url = await urlPromise;
        if (win) {
            win.location.href = url;
        } else {
            window.location.href = url;
        }
    } catch (e) {
        if (win) {
            win.close();
        }
        // eslint-disable-next-line no-console
        console.error("Download konnte nicht geöffnet werden", e);
    }
}
